function menu_dropdowns(){

	// Menu Dropdown
	const dropdowns = document.querySelectorAll('#main-menu > .menu-item-has-children > a');

	if(dropdowns){
		dropdowns.forEach( dropdown => dropdown.addEventListener( 'mouseenter', e => show_submenu(e.currentTarget.parentElement) ) )
	}

	function show_submenu(item){
        
		item.addEventListener( 'mouseleave', hide_submenu, { once: true } )
		const submenu = item.querySelector( '.sub-menu-container' );

        let display = 'block';

        if( item.classList.contains('mega-menu') ){
            display = 'grid';
        }

		submenu.style.display = display;
		
		setTimeout( e => submenu.style.opacity = "1", 10 );
	}

	function hide_submenu(e){
		e.target.removeEventListener( 'mouseleave', hide_submenu );
		const submenu = e.target.querySelector( '.sub-menu-container' );
		submenu.style.opacity = "0";
		setTimeout( e => submenu.style.display = 'none', 300 );
	}


    // Mega Menu 
    let megamenu_items = document.querySelectorAll('.mega-menu > .sub-menu-container > .sub-menu-container__inner > .sub-menu > .menu-item > a');

    if(megamenu_items){

        megamenu_items.forEach( item => {

            item.addEventListener( 'mouseenter', e => {

                let current = document.querySelector('.mega-menu > .sub-menu-container > .sub-menu-container__inner > .sub-menu .current-item')

                if(current){
                    current.classList.remove('current-item')
                }

                set_megamenu_item(e.target);
                
            } );

        } )


        function set_megamenu_item(item){

            item.classList.add('current-item');

            let submenu = item.parentElement.querySelector('.sub-menu');
            let thumb = item.querySelector('.menu-item-thumbnail');

            if( submenu ){
                let clone = submenu.cloneNode(true);
                
                jQuery(item).parents('.sub-menu-container').find('.sub-menu-placeholder').hide().html(clone).fadeIn(500);
            }else{
                jQuery(item).parents('.sub-menu-container').find('.sub-menu-placeholder').hide().html('').fadeIn(500);
            }
            
            if( thumb ){
                let thumb_clone = thumb.cloneNode(true);
                jQuery(item).parents('.sub-menu-container').find('.sub-menu-image').hide().html(thumb_clone).fadeIn(500);
            }else{
                jQuery(item).parents('.sub-menu-container').find('.sub-menu-image').hide().html('').fadeIn(500);
            }

        }

        // set 1st item on load
        set_megamenu_item(megamenu_items[0]);

    }
    
}

export { menu_dropdowns };
